module.exports = __webpack_public_path__ + "img/virtual.d35d950a.svg";